import { ComponentParameter } from "../mlmodel/mlModel-parameters.model";

export class OutputParameter{
  data: ComponentParameter;

  constructor() {
    this.data = new ComponentParameter();
  }
}
